import React from 'react';
import classNames from 'clsx';

import { TipMessageProps } from './TipMessage.interfaces';
import { useStyles } from './TipMessage.styles';

function TipMessage({
  content,
  className,
  icon,
  strongContent,
}: TipMessageProps) {
  const classes = useStyles();
  const contentSeparator = '<br/>';
  const innerContent = content.split(contentSeparator);

  return (
    <div className={classNames(classes.root, className)}>
      <div className={classes.iconContainer}>{icon}</div>
      {strongContent ? (
        <div className={classes.contentContainer}>
          <div className={classes.strongContent}>{strongContent}</div>
          <div className={classes.content}>{innerContent}</div>
        </div>
      ) : (
        <div className={classes.content}>{innerContent}</div>
      )}
    </div>
  );
}

export default TipMessage;
